class StateCallbacks {
  constructor(
    private readonly config: {
      onOpen?: () => void,
      onOpened?: () => void,
      onHide?: () => void,
      onHidden?: () => void,
    },
  ) {
  }

  onOpen(): void {
    if (this.config.onOpen) {
      this.config.onOpen();
    }
  }

  onOpened(): void {
    if (this.config.onOpened) {
      this.config.onOpened();
    }
  }

  onHide(): void {
    if (this.config.onHide) {
      this.config.onHide();
    }
  }

  onHidden(): void {
    if (this.config.onHidden) {
      this.config.onHidden();
    }
  }
}

export { StateCallbacks };
